import { UserProfileRequest } from '../models/request/user-profile.request';
import { OrganismRequest } from '../models/request/organism.request';
import { OrganismModel } from '../models/organism.model';
import { UpdatePasswordRequest } from 'src/app/core/models/request/update-password.request';
import { ActivateAccountRequest } from 'src/app/core/models/request/activate-account.request';
import { OrganismsRegistrationRequest } from '../models/request/organisms-registration.request';
import { VerifyCodeRequest } from '../models/request/verify-code.request';
import { StartRegistrationRequest } from '../models/request/start-registration.request';
import { DeleteAccountRequest } from '../models/request/delete-account.request';
import { RegisterPushIdRequest } from '../models/request/register-push-id.request';
import { ActivityModel } from '../models/activity.model';

export function toUserProfileRequestDTO(
  userId: number,
  nombre: string,
  apellido: string,
  nroDoc: string,
  fechaNac: Date
): UserProfileRequest {
  let request = new UserProfileRequest();
  request.idUsuario = userId;
  request.nombre = nombre;
  request.apellido = apellido;
  request.numeroDocumento = nroDoc;
  request.fechaNacimiento = toStrDate(fechaNac);
  return request;
}

function toStrDate(date: Date): string {
  let auxDate = new Date(date);
  return `${auxDate.getDate()}-${auxDate.getMonth() + 1}-${auxDate.getFullYear()}`;
}

export function toUserOrganismoRequestDTO(
  id: number,
  nombre: string,
  razonSocial: string,
  direccionFiscal: string,
  cuentaBancaria: string,
  numeroCUIT: string,
  condicionIVA: string,
  servicio: string,
  rubro: number
): OrganismRequest {
  let request = new OrganismRequest();
  let organismoDTO = new OrganismModel();

  organismoDTO.id = id;
  organismoDTO.nombre = nombre;
  organismoDTO.razonSocial = razonSocial;
  organismoDTO.tipoDocumento = 'CUIT';
  organismoDTO.numeroDocumento = numeroCUIT;
  organismoDTO.domicilioFiscal = direccionFiscal;
  organismoDTO.condicionIVA = condicionIVA;
  organismoDTO.cbuAlias = cuentaBancaria;
  organismoDTO.rubroServicio = servicio;
  organismoDTO.rubro = new ActivityModel(rubro);

  request.organismoDTO = organismoDTO;

  return request;
}

export function toUpdatePasswordDTO(
  token: string,
  password: string,
  uuid: string,
  appVersion: string,
  version: string
): UpdatePasswordRequest {
  let request = new UpdatePasswordRequest();
  request.uuid = uuid;
  request.codigo = token;
  request.password = password;
  request.versionAplicativo = appVersion;
  request.platform = 1;
  request.version = version;
  request.description = 'Pix-Web';
  return request;
}

export function toActivateAccountDTO(
  token: string,
  uuid: string,
  appVersion: string,
  version: string
): ActivateAccountRequest {
  let request = new ActivateAccountRequest();
  request.codigo = token;
  request.uuid = uuid;
  request.appVersion = appVersion;
  request.platform = 1;
  request.version = version;
  request.description = 'Pix-Web';
  return request;
}

export function toRegisterRequestDTO(
  email: string,
  password: string,
  telefono: string,
  empresa: string,
  recaptchaClientToken: string
): StartRegistrationRequest {
  const request = new StartRegistrationRequest();
  request.email = email;
  request.password = password;
  request.telefono = telefono;
  request.empresaTelefonia = empresa;
  request.recaptchaClientToken = recaptchaClientToken;
  return request;
}

export function toVerifyCodeRequestDTO(codigo: string): VerifyCodeRequest {
  const request = new VerifyCodeRequest();
  request.codigo = codigo;
  return request;
}

export function toRegisterOrganismsRequestDTO(
  email: string,
  password: string,
  comercioCuit: string,
  recaptchaClientToken: string
): OrganismsRegistrationRequest {
  const request = new OrganismsRegistrationRequest();
  request.email = email;
  request.password = password;
  request.cuit = comercioCuit;
  request.recaptchaClientToken = recaptchaClientToken;
  return request;
}

export function toDeleteAccountRequestDTO(password: string): DeleteAccountRequest {
  const request = new DeleteAccountRequest();
  request.password = password;
  return request;
}

export function toRegisterPushIdDTO(uuid: string, platform: number, pushId: string): RegisterPushIdRequest {
  const request = new RegisterPushIdRequest();
  request.uuid = uuid;
  request.platform = platform;
  request.pushId = pushId;
  return request;
}
